import React from "react";
import TractorIcon from "../../shared/TractorIcon";
import useWindowTools from "../../../react-hooks/useWindowTools";
import {t, useEnsureTranslate} from "../../../shared-services/translate";

const translationKey = "banners.free_delivery";

const FreeDeliveryBannerContentCatalogPdp = (props) => {
  const {isMobile} = useWindowTools();
  useEnsureTranslate();

  return (
    <div
      className={`
        flex
        flex-wrap-nowrap
        justify-content-center
        align-items-center
      `}
    >
      <TractorIcon
        style={{
          width: "49px",
          height: "32px",
          minWidth: "49px",
          minHeight: "32px"
        }}
      />
      <div
        className="free-delivery-banner-text"
        style={{marginLeft: isMobile ? "20px" : "24px"}}
      >
        <span dangerouslySetInnerHTML={{__html: t(`${translationKey}.body`)}}/>
        {isMobile &&
          <a
            className="text-color-white text-decoration-none"
            style={{opacity: 0.7, marginLeft: "2px", fontSize: "12px"}}
            href={t(`${translationKey}.link`)}
          >
            <span style={{textDecoration: "underline"}}>
              {t(`${translationKey}.cta`)}
            </span>
            <span>→</span>
          </a>
        }
      </div>
      {!isMobile &&
        <a
          href={t(`${translationKey}.link`)}
          className={`
            flex
            justify-content-center
            align-items-center
            text-decoration-none
            text-color-white
            border-default
            border-color-white
            border-radius-xs
          `}
          style={{
            height: "30px",
            width: "135px",
            minWidth: "135px",
            marginLeft: "35px"
          }}
        >
          {t(`${translationKey}.cta`)}
        </a>
      }
    </div>);
};

export default FreeDeliveryBannerContentCatalogPdp;
